import { SET_ALERT } from "../Actions/actionTypes";

const initialState = {
    alert: false
};

const alertReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ALERT:
            return {
                ...state,
                alert: !state.alert
            }
        default:
            return state;
    }
};

export default alertReducer;